import React from 'react'
import { Helmet } from "react-helmet";

const Profile = () => {
    return (
        <>
            <Helmet>
                <title>My Profile</title>
            </Helmet>
            <div>profile</div>
        </>
    )
}

export default Profile